import React from 'react'

import { ProductContext } from 'common/providers/ProductProvider'

export type CurrentProductDto = {
  productId: number
  productName: string
  signUpTitle: string
  productLogo: string
  productLogoMobile?: string
}

/**
 * @deprecated The method should not be used
 */
const useCurrentProduct = (): CurrentProductDto => {
  const context = React.useContext(ProductContext)
  if (!context) {
    throw new Error(`useCurrentProduct must be used within a ProductProvider`)
  }
  return context
}

export default useCurrentProduct
